import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=21365d66&scoped=true&"
import script from "./SidebarItem.vue?vue&type=script&lang=js&"
export * from "./SidebarItem.vue?vue&type=script&lang=js&"
import style0 from "./SidebarItem.vue?vue&type=style&index=0&id=21365d66&prod&lang=scss&"
import style1 from "./SidebarItem.vue?vue&type=style&index=1&id=21365d66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21365d66",
  null
  
)

export default component.exports